/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { GroupSectionComponent } from './group-section/group-section.component';

@Component({
  selector: 'app-profile-switch',
  templateUrl: './profile-switch.component.html',
  styleUrls: ['./profile-switch.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, GroupSectionComponent],
})
export class ProfileSwitchComponent implements OnInit {
  private readonly sharingData = inject(SharingDataService);
  private readonly authAmplifyService = inject(AuthAmplifyService);
  private readonly translationService = inject(TranslationService);

  test: boolean = false
  isprofileswitchselected: boolean = false
  isMobileMenuVisible: boolean = false
  profileVisible: boolean = false
  isAliasSelected: any
  menuVisible: boolean = true
  userName: any
  userEmail: any
  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.userName = localStorage.getItem('userName')
    this.userEmail = localStorage.getItem('userEmail')
    this.isAliasSelected = localStorage.getItem("profile")
    this.sharingData.getProfileSwitched().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (data) {
        this.isprofileswitchselected = true
      }
    });

    this.sharingData.getProfileSelected().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (data) {
        this.isprofileswitchselected = false
      }
    });
  }
  logout() {
    this.authAmplifyService.logout().subscribe(response => {
      window.location.href = response.body.data;
    });
  }


}
